export const IT = {
    Interno:{
        Principal:"Benvenuti",
        CerrarSesion:"Disconnetti",
        Menu:{
            OrdenCompra:"Ordine di acquisto",
            SolCambioCuenta:"Rich. cambio conto bancario",
            Trabajadores:"Lavoratori",
            Admin:"Admin",
            istracion:"istrazione",
            InvitacionProveedores:"Invito ai fornitori"
        },
        OCDocPendiente:{
            Titulo:"Ordine di acquisto",
            ComoCargo:"Come carico la mia fattura?",
            BuscarOC:"Cerca ordine di acquisto non trovato",
            OC:"OA",
            Contrato:"Contratto",
            FechaOC:"Data OA",
            PorEnviar:"In attesa",
            Certificados:"Certificati",
            Soportes:"Supporti",
            Facturas:"Fatture",
            Accion:"Azione",
            RFCRecept:"RFC Recett.:",
            Moneda:"Valuta",
            FechaReqSitio:"Data richiesta in loco",
            Subtotal:"Subtotale",
            Comprador:"Acquirente",
            Impuestos:"Tasse",
            Activador:"Attivatore",
            Retenidos:"Trattenuti",
            Total:"Totale",
            HeaderFacturasTutorial:"Come carico la mia fattura?",
            Tutorial_Paso1Titulo:"1.- Ordini di acquisto",
            Tutorial_Paso1Desc:'Cerca l\'ordine di acquisto e seleziona l\'opzione "Fatture" nel menu a tendina della colonna azione',
            Tutorial_Paso2Titulo:"2.- Selezione del concetto",
            Tutorial_Paso2Desc:"Carica la fattura per il concetto applicabile.",
            Tutorial_Paso3Titulo:"3.- Caricamento fattura",
            Tutorial_Step1:"Seleziona le voci per calcolare l'importo della fattura (In caso di ricezione materiale).",
            Tutorial_Step2:"Carica il file .xml (Solo applicabile per fornitori messicani).",
            Tutorial_Step3:"Carica il file .pdf.",
            Tutorial_Step4:"Verifica gli importi della fattura.",
            Tutorial_Step5:"Premi il pulsante Invia.",
            Tutorial_BtnVideo:"Guarda il videotutorial",
            Tutorial_BtnCerrar:"Chiudi",
            HeaderBuscarOC:"Ricerca Ordini di acquisto",
            BuscarOCInstruccion:"Inserisci l'ordine di acquisto per vedere il motivo per cui non è visualizzato nell'elenco.",
            BuscarOCLabel:"Ordine Acquisto:",
            BuscarOCBtn:"Cerca",
            Concepto:"Concetto",
            MontoConImpuestos:"Importo con<br>imposte",
            TotalRemision:"Totale<br>Rimessa",
            Facturado:"Fatturato",
            PorFacturar:"Da fatturare",
            Factura:"Fattura",
            Subir:"Carica"
        },
        EnvioFacturas:{
            Titulo:"Invio fatture",
            OrdenCompra:"Ordine di acquisto",
            Moneda:"Valuta",
            FechaReqSitio:"Data richiesta in loco",
            Subtotal:"Subtotale",
            Comprador:"Acquirente",
            Impuestos:"Tasse",
            Total:"Totale",
            Concepto:"Concetto",
            Monto:"Importo",
            Facturado:"Fatturato",
            PorFacturar:"Da fatturare",
            Factura:"Fattura",
            TotalesConImpuesto:"Totali con tasse",
            Subir:"Carica",
            ArchivoXML:"File XML",
            ArchivoPDF:"File PDF",
            NumFactura:"N. fattura",
            Impuesto:"Tassa",
            FechaFactura:"Data fattura",
            TotalFactura:"Totale fattura",
            Referencia:"Riferimento",
            Comentarios:"Commenti",
            BtnCancelar:"Annulla",
            BtnEnviar:"Invia"
        },
        CambioCuentaBancaria:{
            Titulo:"Richiesta cambio conto bancario",
            Motivo:"Motivo del cambio conto bancario:",
            MotivoPH:"Motivo",
            ModalAvisoP1:"La richiesta di cambio conto richiede l'invio della documentazione richiesta e verrà inviata ad Arendal per l'approvazione.",
            ModalAvisoP2:"Contatteremo il rappresentante legale dell'azienda per verificare le informazioni.",
            BtnProceder:"Procedi",
            ModalEnProcesoTitulo:"Richiesta in corso",
            ModalEnProceso:"Esiste già una richiesta di cambio conto bancario questo mese, si prega di attendere una risposta.",
            BtnRegresar:"Indietro",
            Reemplazar:"Sostituisci"
        },
        InvitacionProveedores:{
            Titulo:"Invito ai fornitori",
            Estatus:"Stato",
            VerSoloBtnText:"Visualizza solo i miei inviti",
            BtnInvitar:"Invita",
            FechaInvitacion:"Data invito",
            FechaEstatus:"Data stato",
            Proveedor:"Fornitore",
            Contacto:"Contatto",
            CorreoContacto:"Email contatto",
            InvitadoPor:"Invitato da",
            ColEnviar:"Invia",
            ColCancelar:"Annulla",
            ModalTitulo:"Invita fornitore",
            TipoProveedor:"Tipo fornitore",
            TipoPersona:"Tipo persona",
            SolicitarSubcontratos:"Richiedere documentazione aggiuntiva per subappalti.",
            Proyecto:"Progetto",
            Pais:"Paese",
            RazonSocial:"Rag. soc.",
            RazonSocialPH:"Ragione sociale",
            NomCom:"Nome comm.",
            NomComPH:"Nome commerciale",
            DiasPlazo:"Giorni scadenza",
            DiasPlazoHint:"Giorni di scadenza",
            ProveedorBuscarPH:"Digita 5 caratteri per cercare il fornitore...",
            SeccionContacto:"Contatto",
            Nombres:"Nomi",
            NombresPH:"Nomi",
            Apellidos:"Cognomi",
            ApPaternoPH:"Cognome",
            ApMaternoPH:"Secondo cognome",
            Puesto:"Posizione",
            PuestoPH:"Posizione",
            CorreoLabel:"Email",
            CorreoPH:"email@azienda.com",
            Telefono:"Telefono",
            ComentariosInvitacion:"Commenti invito",
            BtnCancelar:"Annulla",
            BtnEnviarInvitacion:"Invia invito"
        },
        OrdenCompra:{
            a:""
        },
        Trabajadores:{
            a:""
        }
    },
    Externo:{
        Login:{
            TituloLogin:"Accedi con l'email registrata",
            CorreoHint:"Email",
            ContrasenaHint:"Password",
            BtnLogin:"Accedi",
            RecordarContrasena:"Ricorda password",
            OlvideContrasena:"Ho dimenticato la password",
            BtnRegistro:"Registra (Sono già un fornitore Arendal)",
            Notify:{
                IntentosExcedidos:"Il numero di tentativi consentiti è stato superato (5), riprova tra almeno un minuto.",
                TerminoTiempoEspera:"Il tempo è scaduto, riprova.",
                NecesarioCorreoContrasena:"È necessario inserire email e password."
            }
        },
        RegistroProveedor:{
            msgProveedorRegistrado:"I dati del fornitore sono già stati registrati.",
            msgInvitacionNoEncontrada:"L'invito non è stato trovato o è stato eliminato.",
            Titulo:"Informazioni fornitore",
            TituloRegistrado:"Dati registrati con successo.",
            msgTituloRegistrado:"I dati sono stati registrati con successo, attendere l'autorizzazione della registrazione, è possibile chiudere questa finestra.",
            PaisOrigen:"Paese di origine",
            RFCTAX:"RFC / Tax ID",
            NomComercial:"Nome commerciale",
            NomComercialHint:"Nome commerciale",
            RazonSocial:"Ragione sociale",
            RazonSocialHint:"Ragione sociale",
            TipoEmpresa:"Tipo di azienda",
            PersonaMoral:"Azienda",
            PersonaFisica:"Persona fisica",
            DiasPlazo:"Giorni di scadenza",
            ContactoArendal:"Contatto in Arendal",
            ContactoArendalHint:"Gruppo acquisti",
            //?Documentacion
                tabDocumentacion:"Documentazione",
                tabDireccion:"Indirizzo",
                tabDatosContacto:"Dati contatto",
                tabCuentaBancaria:"Conto bancario",
                tbDocumento:"Documento",
                tbDescripcion:"Descrizione",
                tbArchivo:"File (PDF/JPG/PNG/DOC/DOCX)",
                tbSubir:"Carica",
            //?Direccion
                CalleNumero:"Via e numero",
                CalleNumeroHint:"Via e numero",
                Colonia:"Quartiere",
                ColoniaHint:"Quartiere",
                CP:"C.P.",
                CPHint:"Codice postale",
                Ciudad:"Città",
                CiudadHint:"Città",
                Estado:"Provincia",
                EstadoHint:"Provincia",
            //?Contacto
                Nombres:"Nome",
                NombresHint:"Nome",
                PaternoHint:"Cognome",
                MaternoHint:"Secondo cognome",
                Puesto:"Posizione",
                PuestoHint:"Posizione",
                Correo:"Email",
                CorreoHint:"Email",
                Telefono:"Telefono",
                TelefonoHint:"Telefono",
                Direccion:"Indirizzo",
                DireccionHint:"Indirizzo",
            //?Banco
                Moneda:"Valuta",
                Banco:"Banca",
                BancoHint:"Banca",
                NumCuenta:"N. conto",
                NumCuentaHint:"Numero di conto",
                Titular:"Titolare conto",
                TitularHint:"Titolare del conto",
                ABA:"ABA",
                ABAHint:"ABA",
                SwiftCode:"Swift Code",
                SwiftCodeHint:"Swift Code",
            //?Boton Guardar
                BtnGuardarEnviar:"Salva e invia",
            //?Notificaciones
                Notify:{
                    ExtencionIncorrecta:"Selezionare un file pdf, jpg, png, doc, docx.",
                    ArchivoExistente:"Esiste già un file selezionato in precedenza, selezionarne un altro.",
                //?Validaciones Guardado
                    ValidacionSwiftCode:"Inserire il codice swift.",
                    ValidacionABA:"Inserire il codice ABA.",
                    ValidacionTitular:"Inserire il titolare del conto.",
                    ValidacionNoCuenta:"Inserire il numero di conto.",
                    ValidacionBanco:"Inserire la banca.",
                    ValidacionMoneda:"Inserire la valuta.",
                    ValidacionDireccion:"Inserire l'indirizzo del contatto.",
                    ValidacionTelefono:"Inserire il numero di telefono del contatto.",
                    ValidacionCorreo:"Email del contatto non trovata, contattare l'amministratore.",
                    ValidacionPuesto:"Inserire la posizione del contatto.",
                    ValidacionApellidoM:"Inserire il secondo cognome del contatto.",
                    ValidacionApellidoP:"Inserire il cognome del contatto.",
                    ValidacionNombres:"Inserire il/i nome/i del contatto.",
                    ValidacionEstado:"Inserire la provincia.",
                    ValidacionCiudad:"Inserire la città.",
                    ValidacionCP:"Inserire il codice postale.",
                    ValidacionColonia:"Inserire il quartiere.",
                    ValidacionCalleNumero:"Inserire la via e il numero.",
                    ValidacionDiasPlazo:"Inserire i giorni di scadenza.",
                    ValidacionRazonSocial:"Inserire la ragione sociale.",
                    ValidacionNomComercial:"Inserire il nome commerciale.",
                    ValidacionRFC:"Inserire RFC / Tax ID.",
                    ValidacionPais:"Selezionare il paese.",
                    ValidacionDocumentos:"Caricare i documenti mancanti.",
                //?Error peticion
                    ErrorPeticion:"Si è verificato un errore imprevisto, contattare l'amministratore.",
                //?Error Token
                    ErrorToken:"Spiacenti, nessun token valido trovato."
                }
        }
    }
};
